import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import { tradePortalService } from "@/app/services/generated/tradeportalService";
import { useVuetify } from "@/plugins/vuetify";
import { tpBranding } from "@tp/tpBranding";
import { tpSessionData } from "@tp/tpSessionData";
import Cookies from "js-cookie";

const cookieName = (storeId: string) =>
  "tpsession_" + storeId.toLocaleLowerCase();

const ensureSessionEstablishedForStore = async (storeId: string) => {
  if (!storeId) {
    return false;
  }

  if (tpSessionData.currentStoreId() === storeId.toLocaleLowerCase()) {
    // Already established for the given code, so OK.
    return true;
  }

  const fromCookie = Cookies.get(cookieName(storeId));
  if (fromCookie) {
    const parts = fromCookie.split("-");
    return loadTpSession(
      storeId,
      parts[0],
      parts[1]?.toLocaleLowerCase() === "true"
    );
  }

  return false;
};

const storeTpSessionCookie = (
  storeId: string,
  sessionToken: string,
  isMorphedUser: boolean
) => {
  Cookies.set(cookieName(storeId), sessionToken + "-" + isMorphedUser);
};

const loadTpSession = async (
  storeId: string,
  sessionToken: string,
  isMorphedUser: boolean
) => {
  const { $vuetify } = useVuetify();

  try {
    // Getting the tenant will throw if the session token is no longer valid.
    const tenant = await tradePortalService.getTpTenant({ sessionToken });

    // Session token good, so store it so it is used for all future TP Api calls.
    tpSessionData.setSession(sessionToken);

    const tpOutlet = await tradePortalService.getCurrentTpOutlet();
    tpSessionData.setStore(tenant);
    tpSessionData.setOutlet(tpOutlet);
    tpSessionData.setIsMorphedUser(isMorphedUser);
    tenantService.configureForTpTenant(tenant);

    tpBranding.setTenantBranding(tenant, $vuetify);

    storeTpSessionCookie(storeId, sessionToken, isMorphedUser);
    return true;
  } catch {
    clearTpSession(storeId);
    return false;
  }
};

const clearTpSession = (storeId: string) => {
  tpSessionData.setSession("");
  Cookies.remove(cookieName(storeId));
};

export {
  ensureSessionEstablishedForStore,
  loadTpSession,
  storeTpSessionCookie,
  clearTpSession,
};
